import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import createAConnectionWithCalendar_1 from '../../../../../libraries/Images/createAConnectionWithCalendar_1.png';
import createAConnectionWithCalendar_2 from '../../../../../libraries/Images/createAConnectionWithCalendar_2.png';
import createAConnectionWithCalendar_3 from '../../../../../libraries/Images/createAConnectionWithCalendar_3.png';
import createAConnectionWithCalendar_4 from '../../../../../libraries/Images/createAConnectionWithCalendar_4.png';
import createAConnectionWithCalendar_5 from '../../../../../libraries/Images/createAConnectionWithCalendar_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createaconnectionwithcalendar">
                1.&nbsp;{translate('createaconnectionwithcalendar')}
            </Typography>
            <p>接続を作成するように"新規追加"ボタンをクリック</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_1} width="75%" />
            </Zoom>
            <p>連携できるアプリの一覧が表示されるので、その中から「Google Calendar」を選択します。</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_2} width="75%" />
            </Zoom>
            <p>「Google Calendar」をクリックすると、ユーザーのGoogleアカウント選択画面が表示されます。接続に使用するアカウントを選択してください。</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_3} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>アカウントを選択すると、「RPA CLOUD」がユーザーに代わってアクセスを要求します。 「RPA CLOUD」に上記のアクセス権限を付与することに同意し、「許可」をクリックします。</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_4} width="50%" style={{ border: "1px solid rgb(229, 234, 242)" }}/>
            </Zoom>
            <p>接続が正常に作成されると、「Google Calendar」 タグが表示されます。</p>
            <Zoom>
                <img src={createAConnectionWithCalendar_5} width="50%"/>
            </Zoom>
            <p>このタグに含まれる<strong>プロバイダー ID</strong> を使用して「Google Calendar」に関する機能を実行します。</p>
            <br/>
        </Box>
    );
}
export default withTranslate(En);